import jwtDecode, { JwtPayload } from 'jwt-decode';

/** Checks is a token is valid */
export const isTokenValid = (accessToken: string) => {
	if (accessToken) {
		try {
			const decoded = jwtDecode<JwtPayload>(accessToken);
			const currentTime = Date.now() / 1000;
			return decoded.exp > currentTime;
		} catch (error) {
			console.warn(error);
			return false;
		}
	}

	return false;
};

/** Converts an image to a base64 string to use to display */
export const convertImageToBase64 = async (res: Response): Promise<string> => {
	let photoURL = '';

	if (res.ok) {
		const blob = await res.blob();
		photoURL = await new Promise((resolve) => {
			const reader = new FileReader();
			reader.onloadend = () => resolve(reader.result as string);
			reader.readAsDataURL(blob);
		});
		return photoURL;
	}
};
